import { BombCard } from '../BombCard/BombCard';
import { DoubleBonusCard } from '../DoubleBonusCard/DoubleBonusCard';
import { GameItemCard } from '../GameItemCard/GameItemCard';
import { GameOverCard } from '../GameOverCard/GameOverCard';
import { ZeroCard } from '../ZeroCard/ZeroCard';

interface CardsMapType {
  mainPrize: typeof GameItemCard;
  doublePrize: typeof DoubleBonusCard;
  bomb: typeof BombCard;
  empty: typeof ZeroCard;
  stop: typeof GameOverCard;
}

const cardsMap = {
  mainPrize: GameItemCard,
  doublePrize: DoubleBonusCard,
  bomb: BombCard,
  empty: ZeroCard,
  stop: GameOverCard,
} as const;

export { cardsMap, type CardsMapType };
